export default "__VITE_ASSET__RnqgWsc3__"